( () => {
	const expandFilterButton = document.querySelector<HTMLButtonElement>(
		'button[data-ufr-role="popdown-complex-filter-button"]' );

	if ( !expandFilterButton ) return;

	const expandableFilterPopdown = document.getElementById(
		expandFilterButton.getAttribute( 'aria-controls' ) ) as HTMLElement;

	if ( !expandableFilterPopdown ) return;

	expandFilterButton.addEventListener( 'click', () => {
		expandableFilterPopdown.ariaExpanded = expandableFilterPopdown.ariaExpanded === 'true' ? 'false' : 'true';
		expandFilterButton.setAttribute(
			'data-active',
			expandFilterButton.getAttribute( 'data-active' ) === 'true' ? 'false' : 'true',
		);
	} );
} )();
